/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';

import { Container } from './styles';

interface AiLoadingTextProps {
  messages: string[];
  intervalMs?: number;
  className?: string;
}

const AiLoadingText: React.FC<AiLoadingTextProps> = ({
  messages,
  intervalMs = 2600,
  className = '',
}) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);

    if (messages.length <= 1) return undefined;

    const timer = window.setInterval(
      () => setIndex((prev) => (prev + 1) % messages.length),
      intervalMs,
    );

    return () => window.clearInterval(timer);
  }, [messages, intervalMs]);

  const message = messages[index] || messages[0] || '';

  return (
    <Container className={className} role="status" aria-live="polite">
      <span key={message} className="ai-loading-message">
        {message}
      </span>
      <span className="ai-loading-ellipsis" aria-hidden>
        <span>.</span>
        <span>.</span>
        <span>.</span>
      </span>
    </Container>
  );
};

export default AiLoadingText;
